const filterOptions = {
  colors: [
    "Silver/Grey/White",
    "Black",
    "Cream",
    "Mink/Brown",
    "Pink/Purple",
    "Red",
    "Blue",
    "Green",
    "Turmeric",
    "Orange",
  ],
  tones: ["Dark", "Light", "Mix Tones"],
  materials: [
    "Glitz Crushed Velvet",
    "French Plush Velvet",
    "Plain Naples Velvet",
    "House Coniston Velvet",
    "Marble Velvet",
    "Greek Mystic Printed Velvet",
    "British Bouclé Teddy",
    "Australian Wool",
    "Swiss Chenille",
    "Egyptian Linen",
    "Faux Leather",
    "Suede",
  ],
};

const createCheckbox = (type, className) => {
  const p = document.createElement("p");
  const input = document.createElement("input");
  input.type = "checkbox";
  input.dataset.type = type;
  input.className = className;
  const label = document.createElement("label");
  label.textContent = type;

  p.appendChild(input);
  p.appendChild(label);
  return p;
};

const createSection = (container, title, items, className) => {
  if (!container) return;

  const heading = document.createElement("h4");
  heading.textContent = title;
  container.appendChild(heading);

  items.forEach((item) => {
    const element = createCheckbox(item, className);
    container.appendChild(element);
  });
};

const populateFilter = () => {
  const colorBox = document.getElementById("color-options-swatches");
  const toneBox = document.getElementById("tone-options-swatches");
  const materialBox = document.getElementById("material-options-swatches");
  createSection(colorBox, "Select colour", filterOptions.colors, "colorChange");
  createSection(toneBox, "Select tone", filterOptions.tones, "toneChange");
  createSection(
    materialBox,
    "Select material",
    filterOptions.materials,
    "materialChange"
  );
};

const showMobileFilter = ()=>{
    const filterBar = document.getElementById("filter-bar");
    const modalBody = document.getElementById("modal-filter-body");
    modalBody.append(filterBar)
}

$(window).on("load", function () {
  populateFilter();
});
